import React, { useContext, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { ChatContext } from 'context/Context';
import classNames from 'classnames';

const VoiceSelect = () => {
    const [showDrop, setShowDrop] = useState(false);
    const { voiceURIs, setSelectedVoice } = useContext(ChatContext);
    return (
        <Dropdown drop="up" show={showDrop} onToggle={() => setShowDrop(!showDrop)}>
            <Dropdown.Toggle
                className={classNames('h-100', { 'text-secondary': !showDrop, 'text-primary': showDrop })}
                id="btnSelectVoice"
                variant="falcon-default"
                title="Select the voice to be used."
            >{<FontAwesomeIcon icon={faHeadset} />}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {voiceURIs && voiceURIs.map((v) =>
                (<Dropdown.Item
                    key={v.voiceURI}
                    onClick={e => {
                        e.stopPropagation();
                        setSelectedVoice(v.voiceURI);
                        setShowDrop(false);
                    }}
                    eventKey={v.voiceURI}
                >{v.name}
                </Dropdown.Item>)
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default VoiceSelect;